<div class="card card-white-bg position-relative py-2 px-3" [style.cursor]="!editable ? 'auto' : null" (click)="onCardClicked($event)">
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute p-2" style="top:0px; right:0px" (click)="onDeleteClicked($event)" *ngIf="editable === true">
        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
    </button>

    <div class="componentValues d-flex flex-column">
        <div class="d-flex flex-nowrap componentValue">
            <div class="subtitle-2 componentValueHeader"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Reporting_Set_Name">Reporting Set Name</span>:&nbsp;</div>
            <div class="body-1 data-value">{{model?.reportingSetName}}</div>
        </div>

        <!-- Start Date / "Metric Date" -->
        <div class="d-flex flex-nowrap componentValue" *ngIf="model?.metricType != 1">
            <div class="subtitle-2 componentValueHeader"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Start_Date">Start Date</span>:&nbsp;</div>
            <div class="body-1 data-value">{{model?.metricDate}}</div>
        </div>

        <!-- End Date, if Metric Value of Time -->
        <div class="d-flex flex-nowrap componentValue" *ngIf="model?.metricValue == 1">
            <div class="subtitle-2 componentValueHeader"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="End_Date">End Date</span>:&nbsp;</div>
            <div class="body-1 data-value">{{model?.endDate}}</div>
        </div>

        <!-- Data Value -->
        <div class="d-flex flex-nowrap componentValue" *ngIf="model?.metricValue == 0">
            <div class="subtitle-2 componentValueHeader"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Data_Value">Data Value</span>:&nbsp;</div>
            <div class="body-1 data-value">{{model?.dataValue}}</div>
        </div>

        <!-- Add Filter and Attribute filters here -->
        <div class="mt-2" *ngIf="model?.filterFields.length > 0">
            <div><span class="subtitle-2 pr-8" cvLocalizedText langSection="Pipeline_Configuration" langKey="Component_Filter_Fields">Filter Fields</span>:</div>
            <div class="lato-light-i color-no2Pencil" *ngFor="let filterField of model?.filterFields">
                <span>{{filterField.EvalField}} </span><span *ngFor="let compValue of filterField.CompValues; first as isFirst">{{formatCompValue(filterField, compValue, isFirst)}}</span>
            </div>
        </div>
    </div>
</div>
